/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheckboxWithInputText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaCheckboxWithInputText({
  children,
  viewPath = "/DesignSystem/TysiaCheckboxWithInputText",
  marginRight,
  marginLeft,
  marginTop,
  marginBottom,
  value,
  onSubmit,
  onChange,
  disabled,
  invalid,
  size,
  text
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginRight={marginRight}
 marginLeft={marginLeft}
 marginTop={marginTop || dtSpaceS}
 marginBottom={marginBottom}
 value={value}
 onSubmit={onSubmit}
 onChange={onChange}
 disabled={disabled}
 invalid={invalid}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 size={size}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text={text}
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}